import en from './en.json'
import it from './it.json'

export const poTranslations = { en, it }
